import React from "react"

const toneMap = {
  neutral: {
    background: "#f8fafc",
    border: "#e2e8f0",
    color: "#334155"
  },
  info: {
    background: "#eff6ff",
    border: "#bfdbfe",
    color: "#1d4ed8"
  },
  success: {
    background: "#f0fdf4",
    border: "#bbf7d0",
    color: "#166534"
  },
  warning: {
    background: "#fff7ed",
    border: "#fed7aa",
    color: "#c2410c"
  },
  danger: {
    background: "#fef2f2",
    border: "#fecaca",
    color: "#991b1b"
  }
}

export default function StatusPill({ children, tone = "neutral", style = {} }) {
  const visual = toneMap[tone] || toneMap.neutral

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        minHeight: 26,
        padding: "0 9px",
        borderRadius: 999,
        background: visual.background,
        border: `1px solid ${visual.border}`,
        color: visual.color,
        fontSize: 11.5,
        fontWeight: 800,
        lineHeight: 1,
        whiteSpace: "nowrap",
        ...style
      }}
    >
      {children}
    </span>
  )
}
